import React from "react";
import { aboutPoints, company } from "../mock";

export default function About() {
  return (
    <section className="section-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="eyebrow eyebrow-line">About {company.shortName}</p>
            <h2 className="font-serif-display mt-6 text-[2.1rem] md:text-[3rem] leading-[1.05] text-[#2a3325]">
              A US firm with a <span className="italic-accent">global</span> book of owners.
            </h2>
            <p className="mt-6 text-[#4d5a45] leading-relaxed max-w-lg">
              {company.name} is a US-registered practice retained by property owners across the world’s major capitals — with prime London as the market where our bench runs deepest.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6">
              <Stat label="Registered" value="Wyoming, USA" />
              <Stat label="Anchored in" value="London W1D" />
              <Stat label="Clients across" value="6 continents" />
            </div>
          </div>

          <div className="lg:col-span-6 lg:pl-10 lg:border-l border-[#c4cfb2]">
            <ul>
              {aboutPoints.map((p, i) => (
                <li key={p.n} className={`py-6 ${i !== aboutPoints.length - 1 ? "border-b border-[#c4cfb2]" : ""}`}>
                  <div className="flex gap-8">
                    <span className="font-serif-display italic-accent text-lg pt-1">{p.n}</span>
                    <div>
                      <h3 className="font-serif-display text-2xl text-[#2a3325]">{p.title}</h3>
                      <p className="mt-2 text-[#4d5a45] leading-relaxed text-sm">{p.desc}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div className="border-t border-[#c4cfb2] pt-4">
      <p className="eyebrow">{label}</p>
      <p className="font-serif-display text-xl md:text-2xl text-[#2a3325] mt-3">{value}</p>
    </div>
  );
}
